import { SelectItem } from "primeng/api";

export class MemberInfo{
  Member: Member;
  Pets: Pet[];

  constructor(){
    this.Member = new Member;
    this.Pets = [];
  }
}
export class Member {
  CompanyID: string;
  Email:string;
  LineID:string;
  Name:string;
  Telephone:string;
  Telephone1:string;
  Gender:number;
  Birthday:string;
  Add1:string;
  Add2:string;
  Add3:string;
  UnionID: string;
  
  PetName:string;
  VarietyType:any;
  /**品種(代碼編號) */
  Variety:any;
  PetGender: number;

  /**會員卡號 */
  MemberID:string;
  MemberNo:string;
  MemberLevel:string;

  /// <summary> 緊急聯絡人 </summary>
  Contact: string
  /// <summary> 與飼主關係 </summary>
  Relationship: string;
  /// <summary> 聯絡電話 </summary>
  ContactTel: string;
  /// <summary> 動物醫院名稱 </summary>
  Hospital: string;
  /// <summary> 動物醫院電話 </summary>
  HospitalTel: string;
  /// <summary> 動物醫院地址 </summary>
  HospitalAddress: string;
}

export class Pet{
  CompanyID: string;
  PetNo: string;
  PetName: string;
  MemberNo:string;
  Gender: string;
  Color: string;
  /**體型(代碼編號) */
  Size: string;
  /**體型(代碼名稱) */
  SizeName: string;
  Birthday: string;
  /**品種(代碼編號) */
  Variety:any;
  /**品種(代碼名稱) */
  VarietyName:string;
  Notes:string;
  VarietyList: SelectItem[] | null = null;
  VarietyType:any;
  VarietyTypeName:string;
  PhotoPath: string;
  OldPhotos: any[] = [];
  gallyBox: any[] = [];
  NewPhotos: any[] = [];
  NewPhotoUrls: any[] = [];
  /** 寵物病史 */
  PetMedicalHistory: PetMedicalHistory;
  /**貓砂 */
  CatLitterList: CatLitter;
  VaccineList: Vaccine;
  /** 是否已經結紮(Y=是, N=無) */
  SterilizationFlag: string;
  /**是否接送 */
  CarryFlag: string;
  /**是否晶片 */
  hasWafer: string;
  /**疫苗日期 */
  vaccineDate: string;
}
export class PetMedicalHistory {
  /// <summary> 會員編號 </summary>
  MemberNo: string;
  /// <summary> 寵物編號 </summary>
  PetNo: string;
  /// <summary> 寵物病史 </summary>
  MedicalHistoryItems: CheckBoxItem[];
  /// <summary> 寵物病史(其他) </summary>
  MedicalHistoryItemsNote: string;
}
export class CatLitter{
  /// <summary> 會員編號 </summary>
  MemberNo: string;
  /// <summary> 寵物編號 </summary>
  PetNo: string;
  Items: CheckBoxItem[];
  Note:string;
}

export class Vaccine{
  /// <summary> 會員編號 </summary>
  MemberNo: string;
  /// <summary> 寵物編號 </summary>
  PetNo: string;
  Items: CheckBoxItem[];
  vaccineDate: string;
  Note:string;
}
export class CheckBoxItem{
  Id:string;
  Selected:boolean;
  Name:string;
  Note:string;
}